var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBird3 = function SvgBird3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 286 286"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m255 277.5-34.8-34.8-5.3-5.3-5.3 5.3-29.6 29.5v-84.7l37.5-15-37.5-15v-15H82.5V255l-30 30H270v-7.5zm-10.6 0h-59.1l29.5-29.5zM150 180c-4.1 0-7.5-3.4-7.5-7.5s3.4-7.5 7.5-7.5 7.5 3.4 7.5 7.5-3.4 7.5-7.5 7.5"
  })));
};
export default SvgBird3;